export default __webpack_public_path__ + "static/media/file-upload-solid.3cf90a11.svg";